import { render, staticRenderFns } from "./OutreachRequestList.vue?vue&type=template&id=c196022a&scoped=true"
import script from "./OutreachRequestList.vue?vue&type=script&lang=ts"
export * from "./OutreachRequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c196022a",
  null
  
)

export default component.exports